/****** create file by codeGen ******/
import Config from '../../config/index';
import Axios from 'axios';
import remote from '@/util/Remote';

const env = process.env.CURRENT_ENV || 'production';

export const getNewDetailByHttp = (params) => {
  return new Promise((resolve, reject) => {
    return Axios(
      {
        method: 'POST',
        url: `${Config[env].himikoUrl}/xl-contentApi/domainChange/invoker.do`,
        headers: {
          'Content-Type': 'application/json',
          domainVersion: params.domainVersion,
          domainPlatformType: params?.environment === 'wx_browser' ? 0 : 1,
        },
        data: {
          ...params,
          domainPlatformType: 0
        }
      }
    )
      .then(response => {
        resolve && resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  })
}

export const getAddress = (params = {}) => {
  return remote.get(`/cutomer/addess/getAddress`, params, {
    urlType: 'sales',
  });
}

///customer/address/search.do
export const searchAddress = (params = {}) => {
  return remote.get(`/customer/address/search.do`, params, {
    urlType: 'sales',
  });
}

//api/client/activityComponent/appointment/queryAddressByLonLat.do?longitude=116.481488&latitude=39.990464
export const queryAddressByLonLat = (params = {}) => {
  return remote.get(`/client/activityComponent/appointment/queryAddressByLonLat.do`, params);
}
